import {PlatformDTO} from './platformDTO.interface';
import {BaseDTO} from "./_baseDTO.interface";

export interface LocationDTO extends BaseDTO {
  locationName?: string;
  platformId?: string;
  platform?: PlatformDTO;
}
